<template>
    <v-container fluid justify-center>
    <v-layout row wrap mb-2 >
        <v-flex xs12 sm3  class="subheading">
            <strong><b>Subscriptions</b></strong>
        </v-flex>
        <v-flex xs3 v-if="$mq!='mobile'">&nbsp;</v-flex>
        <v-flex xs9 sm4>
            <v-text-field
            v-model="search"
            small
            append-icon="search"
            label="Search" 
            class="black--text "
            color="black"
            single-line
            outline
            style="padding:0px;margin:0px"
            hide-details
            ></v-text-field>
        </v-flex>
        <v-flex xs2>
            <div class="text-xs-right">
                <v-btn @click ="UpdateBulk" v-if="selected.length!=0" small class="teal white--text">
                <v-icon slot="activator" flat class="indigo--text" >edit</v-icon>
                &nbsp;Bulk Update
                </v-btn>
                <v-tooltip top>
                    <v-icon slot="activator" flat class="grey--text" @click ="$router.push('/subscribe2')">add</v-icon>
                    <span>Add </span>
                </v-tooltip>
                <v-tooltip top>
                    <v-icon slot="activator" flat class="grey--text">print</v-icon>
                    <span>Print</span>
                 </v-tooltip>
                <v-tooltip top>
                <v-icon slot="activator" flat class ="grey--text">mdi-download</v-icon>
                <span>Download</span>
               </v-tooltip>
                <v-tooltip top> 
                <v-icon  slot="activator"  flat class="grey--text">mdi-export</v-icon>
                    <span>Export</span>
                </v-tooltip>
                <v-tooltip top>
                <v-icon  slot="activator"  flat class="white--text">delete</v-icon>
                <span>Delete</span>
                </v-tooltip>
            </div>
            </v-flex>
            <br/>
        </v-layout>
                 <v-layout row v-if="!loadingTable" class="justify-center" style="padding:30px">
                           <span class="headline grey--text"><strong>Loading Data... </strong></span>
                </v-layout>
                <v-layout row v-if="!loadingTable" class="justify-center" style="padding:10px">
                  
                  <Socket  class = '#36D7B7'  style="zoom:160%"
                   >
                   </Socket>
                   
                   </v-layout>
               
            <v-data-table
            v-if="loadingTable"
                :headers="headers"
                :items="reportSubscriptions"
                :search="search"
                 select-all
                 v-model="selected"
                 :pagination.sync="pagination"
                 :rows-per-page-items="pagination.rowsPerPageItems"
                >
                <template slot="items" slot-scope="props">
                    <td>
                <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                ></v-checkbox>
                </td>
                <td width="5%" v-if="$mq!='mobile'"> 
                    <span style="cursor:pointer"   class="navy--text" @click="editItem(props.item.id,'E')">{{ props.item.id }}</span>
                        
                </td>
                    <td :width="$mq!='mobile' ? '25%' : '80%'" class="text-xs-left" >
                        <v-icon small color="orange" v-if="isPpt(props.item) && $mq!='mobile'">far fa-file-powerpoint</v-icon>
                        <v-icon small color="red" v-if ="isPdf(props.item) && $mq!='mobile'">far fa-file-pdf</v-icon>
                        <v-icon small color="green" v-if ="isExcel(props.item) && $mq!='mobile'">far fa-file-excel</v-icon>
                         <v-icon small color="black" v-if ="isCsv(props.item) && $mq!='mobile'">far fa-file-csv</v-icon>
                         &nbsp;
                        <span style="cursor:pointer"   class="navy--text" @click="editItem(props.item.id,'E')">{{ props.item.name }}</span>
                        
                    </td>
                    <td class="text-xs-left" width="13%" v-if="$mq!='mobile'">   
                        <span > {{moment(props.item.next_date).format('MM/DD/YYYY HH:mm ')}}</span>
                        <br/>
                           <strong>Interval:</strong> {{props.item.schedule_at.interval }}
                           <br/>
                             <span style="color:#FF9315">{{moment(props.item.next_date).fromNow()}}</span>
                             </td>
                  
                    <td width="8%" v-if="$mq!='mobile'">
                        <span >{{ props.item.owner  }}</span>
                        
                    </td>
                    <td width="13%" v-if="$mq!='mobile'"> 
                        <template v-for="email in props.item.email_to">
                                  {{email}}<br/>
                        </template>
                    </td>
                    <td class="text-xs-left" width="10%" v-if="$mq!='mobile'">
                        <v-chip small color="primary" text-color="white">
                            {{ props.item.active == 1 ? 'Active':'InActive    '}}
                        </v-chip>
                    </td>
                    <td width="9%" class="text-xs-left" v-if="$mq!='mobile'">{{ props.item.companies.name }}</td>
                    <td width="10%" v-if="$mq=='mobile'">
                      
                         <IconStop  v-if="props.item.processing" @clicked="stopProcessing(props.item)"/>
                          <v-progress-circular
                            :width="2"
                            color="red"
                            indeterminate
                            style="padding:0px;margin:0px"
                            small
                            size="15"
                            v-if= "props.item.processing" 
                            >
                        </v-progress-circular>  
                        <ReportCogs v-if="!props.item.processing"  @clicked="value => {cogsClicked(value,props)}"/>
                    </td>
                    <td width="32%" v-if="$mq!='mobile'">
                        <IconStop v-if="props.item.processing" @clicked="stopProcessing(props.item)"/>
                        &nbsp;
                        <IconEye @clicked="editItem(props.item.id)"/>
                         &nbsp;
                        <IconEdit @clicked="editItem(props.item.id)"/>
                        &nbsp;
                        <IconPlay v-if= "!props.item.processing" @clicked="generateReport(props.item,props.index)"/>
                        &nbsp;
                        <IconDownload v-if= "!props.item.processing" @clicked="getLink(props.item)"/>
                         &nbsp;
                        <IconTrash v-if= "!props.item.processing"  @clicked="changeStatus(props.item,props.index)"/> 
                        &nbsp; 
                        <IconClone v-if= "!props.item.processing"  @clicked="cloneReport(props.item,props.index)"/>            
                        <v-progress-circular
                            :width="2"
                            color="red"
                            indeterminate
                            small
                            size="15"
                            v-if= "props.item.processing" 
                            >
                        </v-progress-circular>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
              <v-dialog v-model="dialog" persistent max-width="900px">
                <BulkUpdate v-if="dialog" :selectedData="bulkUpdates" v-on:changesApplied="closeDialog" />
             </v-dialog>
        </v-container>
</template>
<script>
import ReportCogs from './ReportCogs.vue'
import IconEye from '@/components/Icons/IconEye.vue'
import ReportSubscriptionModel from '@/api/service/ReportSubscriptionService';
import {Socket} from 'vue-loading-spinner'
import BulkUpdate from './BulkUpdate.vue'
import IconEdit from '@/components/Icons/IconEdit.vue'
import IconPlay from '@/components/Icons/IconPlay.vue'
import IconDownload from '@/components/Icons/IconDownload.vue'
import IconTrash from '@/components/Icons/IconTrash.vue'
import IconStop from '@/components/Icons/IconStop.vue'
import IconClone from '../../../../components/Icons/IconClone.vue';


import moment from 'moment'

  export default {
      components:{
          Socket,
          ReportCogs,
          BulkUpdate,
          IconEye,
          IconEdit,
          IconPlay,
          IconDownload,
          IconTrash,
          IconStop,
          IconClone
      },
    data () {
      return {
            dialog:false,
            selectedRow:'',
            bulkUpdates: {},
            loadingTable:false,
            search: '',
            rowsPerPageItems: ['50', '100', '200', '400','All'],
            selectedEmails:{},
            processing:[],
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 250,
                sortBy: 'id',
                totalItems: 0,
                rowsPerPageItems: [10, 50, 100, 250,500,-1]
            },
            selected: [],
            headers: [
               
            ],
        reportSubscriptions: [
        ]
      }
    },
    created: function() {
      this.setHeader()
      this.fetchSubscriptions()
    },
    watch: {
      'pagination.rowsPerPage': function() {
        this.fetchSubscriptions()
      }
    },
    
    // mounted: function(){
    //      var $opx = {}
  
    //   if(this.$store.getters.userInfo.super_user!=1) {
    //       $opx = {"created_by":this.$store.getters.userInfo.id,"active":1}
    //   }
    //     ReportSubscriptionModel.findAll($opx)
    //         .then(response => {
    //             setReportSubscriptions(response)                
    //         }).catch(error => {

    //     }); 
    //     this.setPolling()
    // },
    methods: {
        moment,
        fetchSubscriptions() {
            var $opx = {}
            if (this.$store.getters.userInfo.super_user != 1) {
                $opx = { "created_by": this.$store.getters.userInfo.id, "active": 1 }
            } else {
                $opx = this.pagination.rowsPerPage === -1 ? {} : { "limit": this.pagination.rowsPerPage }
            }
            this.loadingTable = false
            ReportSubscriptionModel.findAll($opx)
                .then(response => {
                    this.setReportSubscriptions(response)
                }).catch(error => {
                // { text: 'Next Run', value: 'next_date' },
                })
        },
        setHeader() {
            if(this.$mq=='mobile') {
              this.headers=[
                { text: 'Name', value: 'name',class:'text-xs-left' },
              
                {}
             ]
            } else {
             this.headers=[
                 { text: 'Id', value: 'id',class:"text-xs-left" },

                { text: 'Name', value: 'name',class:'text-xs-left' },
                { text: 'Next Run', value: 'next_date' },

                { text: 'Owner', value: 'owner' },
                { text: 'Email To',value:"email_to"},
                { text: 'Active', value: 'active' },
                { text: 'Company', value: 'company' },
                {}
             ]
            }
        },
        cogsClicked($item,props) {
            switch($item) {
                case 'run':
                    this.generateReport(props.item,props.index)
                    break;
                case 'download':
                    getLink(props.item)
                    break;
                case 'delete':
                    this.changeStatus(props.item,props.index)
                    break;
                
            }
        },
        closeDialog() {
            this.dialog=false
            window.location.reload()
        },
        setReportSubscriptions($reportSubscriptions){
            this.reportSubscriptions=$reportSubscriptions;
            var $i=0;
            console.log($reportSubscriptions)
            for($i=0;$i<$reportSubscriptions.length;$i++) {
                if($reportSubscriptions[$i].processing) {
                    this.processing.push({"id":$reportSubscriptions[$i].id,"index":$i})
                }
            }
            this.loadingTable=true
        },
        stopProcessing($report) {
          ReportSubscriptionModel.save({'id':$report.id,processing:0})
            .then(response => {
                $report.processing=0
            })
          
        },
        viewItem(id) {
            var $url ='/subscribe2/view?id='+id
            this.$router.push($url)
        
        },
        editItem(id) {
            var $url ='/subscribe2?id='+id
            this.$router.push($url)
        },
        generateReport(item,index) {
            
        item.processing = 1    
        //this.setProcessing(index,1) 
        this.processing.push({"id":item.id,"index":index})
            ReportSubscriptionModel.submitReport(item.id)
            .then(response => {
                //this.setPolling()
                //  console.log(response)
                //this.setProcessing(index,1,response.data.data[0].report_log_id)
                item.processing = 0
                //alert(JSON.stringify(response.data))
                item.report_log_id = response.data.data[0].report_log_id
            }).catch(error => {

        }); 
        },
        isPpt(item){
      return item.export_options.file_type === "Ppt";
    },
        isPdf(item) {
            console.log(item.export_options.file_type)
            return item.export_options.file_type==='Pdf';
        },
        isExcel(item) {
            console.log(item.export_options.file_type)
            return item.export_options.file_type==='Excel';
        },
        isCsv(item) {
            console.log(item.export_options.file_type)
            return item.export_options.file_type==='Csv';
        },
        isProcessing($item) {
          //  alert(JSON.stringify($item)  )
          //alert($item)
          //this.selectedRow = $item
           return $item.processing
        },
        setProcessing($index,$status,$logId) {
            this.reportSubscriptions[$index].processing=$status
            if($logId) {
                this.reportSubscriptions[$index].report_log_id=$logId
            }
            
            
        },
        setProcessingStatus($status) {
            console.log($status)
            var $processing = this.processing
            var $newStatus =[]
            var $i=0;
            var $id
            var $index
            console.log(this.processing)
            for($i=0;$i<$processing.length;$i++) {
                $id = $processing[$i].id
                $index = $processing[$i].index
                console.log($status.data.data[$id])
                if($status.data.data[$id].status==0) {
                       this.setProcessing($index,0)
                }
                else {
                    $newStatus.push({"id":$processing[$i].id,"index":$processing[$i].index})
                }
            }
            //this.processing.push($newStatus)
        },
        getLink($item) {
    
            var fileType = $item.export_options.file_type === 'Ppt' ? '.pptx' : $item.export_options.file_type === 'Pdf'? '.pdf':'.xlsx' 
            var id = $item.report_log_id + fileType
            this.$router.push('download?id=' + id)    
            
          //  this.$router.push('download?id='+$item.report_log_id)
            /*var $fileType = $item.export_options.file_type

            switch($fileType) {
                case 'Pdf':
                     return '/files/'+$item.name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '')+'-'+$item.report_log_id+".pdf"; break;
                case 'Excel': 
                  return '/files/'+$item.name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '')+'-'+$item.report_log_id+".xlsx"; break;
                
            }*/
           // return {"path":'/files/'+item.report_log_id+".xlsx"}

           //console.log(item)
           //this.$router.push('/files/'+item.report_log_id+".xlsx")
        },
        changeStatus(item,index) {
            //var $status = !(item.active===1)
            ReportSubscriptionModel.save({"id":item.id,"active":0})
            .then(response => { 
                window.location.reload()
            }).catch(error => {

        }); 

        },
        cloneReport(item,index) {
            //var $status = !(item.active===1)
            item.columns=JSON.stringify(item.columns)
           item.schedule_at=JSON.stringify(item.schedule_at)
           item.filter_options=JSON.stringify(item.filter_options)
           item.sort_options=JSON.stringify(item.sort_options)
           item.layout_options=JSON.stringify(item.layout_options)
           item.export_options=JSON.stringify(item.export_options)
           item.email_to=JSON.stringify(item.email_obj)
           item.schedule_day=JSON.stringify(item.schedule_day)

            delete item.id
            delete item.company
            delete item.companies
            delete item.reports
            delete item.owner
            delete item.user
            delete item.email_obj

            ReportSubscriptionModel.create(item)
            .then(response => { 
                window.location.reload()
            }).catch(error => {
          console.log(error)
        }); 

        },
        UpdateBulk() {
            for(var $i=0;$i<this.selected.length;$i++) {
            var $address = this.selected[$i].email_to
            for(var $k=0;$k<$address.length;$k++) {
                if(this.selectedEmails[$address[$k]]) {

                } else {
                    this.selectedEmails[$address[$k]]=true
                }
            }
        }
        this.bulkUpdates= {"selectedIds":this.selected,"emails":this.selectedEmails}
            this.dialog= true
          
        },
        setPolling() {
           console.log(this.processing)

         /*if(this.processing.length!=0) {
            console.log('polling')
            console.log(this.processing)
           */
         /*  setInterval(() => {
                ReportSubscriptionModel.getStatus(this.processing)
                    .then(response => {
                        this.setProcessingStatus(response)
                    });
            }, 15000); */
        //}
        }
    }

  }
</script>
<style>
table {border-spacing: 2px;}
td    {padding: 6px;vertical-align:top}
.v-text-field input {
    padding:0px !important;
}
</style>